<script>
  import { Section } from "@ObamaFoundation/of-design-system";

  /** @type { string } */
  let className = "";
  export { className as class };

  export let title = undefined;
  export let theme = undefined;
  export let cta = undefined;
  export let variant = undefined;
</script>

<Section {title} {theme} {cta} {variant} class="section {className}" titleTag="h2">
  <slot />
</Section>
